import { initContract } from "@ts-rest/core";
import z from "zod";

import { coverageStatusEnumSchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types.ts";
import { errorSchema } from "../../utils/errors.ts";

const c = initContract();

export const coverageContract = c.router({
  checkCoverage: {
    path: "/coverage/check",
    summary: "Check patient's coverage eligibility",
    method: "POST",
    body: z.object({
      householdMemberId: z.uuid(),
    }),
    responses: {
      [HTTPStatusCode.OK]: z.object({
        coverageStatus: coverageStatusEnumSchema,
      }),
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
});
